import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Typography } from '@mui/material';
import PrimaryButton from '../../../Common/Button/PrimaryButton';
import { useNavigate, useLocation } from 'react-router-dom';
import { fetchTemplates, createTemplate, fetchTemplateById, checkTemplateNameAvailability } from '../../../../Services/APIConfig';
import { holdTemplateNames } from '../../../../Store/Redux/FileListSlice';
import { useDispatch, useSelector } from 'react-redux';
import { updateContent } from '../../../../Store/Redux/CKEditorSlice';
import GenerateThumbnail from '../../../../utils/GenerateThumbnail';
import { mapFields } from '../../../../utils/MapInputFields';
import { mapTables } from '../../../../utils/MapTables';
import { getDropdownFields, getInputFields } from '../../../../utils/CkMapInputFields';
import { pageSizes } from '../../../../utils/PageSizes';
import Loading from '../../../Common/LoaderComponent/Loader';
import CustomToast from '../../../Common/CustomToast';

const CreateNewTemplate = ({ open, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { filesList } = useSelector(state => state.fileList);
  const params = new URLSearchParams(location.search);
  const [cancelClickedOnce, setCancelClickedOnce] = useState(false);
  const [localTemplateName, setLocalTemplateName] = useState('');
  const [showTextField, setShowTextField] = useState(false);
  const [message, setMessage] = useState('');
  const fileID = params.get('fileId');
  const createmode = params.get('createmode');
  const { editorPageSize, borderAndMargin } = useSelector(state => state.ckeditor);
  const { stampConfig,isAdditionalAmountRequired,additionalCharges } = useSelector(state => state.fileList);
  const [isLoading, setIsLoading] = useState(false);
  const { showToast } = CustomToast();

  useEffect(() => {
    const createTemplateAndNavigate = async () => {
      try {
        setIsLoading(true);
        const editor = document.querySelector('#editor').innerHTML;
        const isValid = await checkContentValidity(editor);
        if (!isValid) return;

        setMessage('Are you sure you want to create a new template.');
      } catch (error) {
        setMessage(error.message);
      }finally{
        setIsLoading(false);
      }
    };

    createTemplateAndNavigate();
  }, []);

  const handleCancelTemplate = () => {

    // if (cancelClickedOnce) {
      onClose(false);
      setCancelClickedOnce(false);
      setShowTextField(false);
      setMessage('');
    // } else {
    //   setCancelClickedOnce(true);
    //   setMessage('Are you sure you want to cancel? Click again to navigate back.');
    // }
  };

  const checkTemplateNameValidity = async fileName => {
    try {

      if (fileName.trim() === '') {
        showToast('warning', 'Template name is empty, please provide a valid name for the template.');
        return false;
      }

      const trimmedFileName = fileName.trim();
      const isNameTooShort = trimmedFileName.length < 3;
      const isNameTooLong = trimmedFileName.length >= 30;

      if (isNameTooShort) {
        showToast('warning', 'Please provide a name greater than or equal to 3 characters.');
        setCancelClickedOnce(false);
        return false;
      }

      if (isNameTooLong) {
        showToast('warning', 'Please provide a name less than or equal to 30 characters.');
        setCancelClickedOnce(false);
        return false;
      }
      
      const response = await checkTemplateNameAvailability(trimmedFileName);

      if(response?.status === 200){
        return true;
      }else{
        showToast('warning', response?.error || 'Template name not available.');
        return false;
      }
    } catch (error) {
      showToast('error', error?.message || 'An error occurred while checking the content API.');
      return false;
    }
  };

  const checkContentValidity = async htmlContentPath => {
    try {
      const response = await fetchTemplateById(fileID);
      const isContentAlreadyPresent = response.data && response.data.templateId === fileID;

      if (!isContentAlreadyPresent) {
        setMessage(
          'Content in the API is not the same as the current editor. Proceed without saving the current content?'
        );
        setCancelClickedOnce(false);
        return false;
      }

      return true;
    } catch (error) {
      setMessage('An error occurred while checking the content API.');
      return false;
    }
  };

  const handleCreateNewTemplate = async () => {
    if (!showTextField) {
      if (message === 'Are you sure you want to create a new template.') {
        setShowTextField(true);
        setMessage('');
      } else if (
        message ===
        'Content in the API is not the same as the current editor. Proceed without saving the current content?'
      ) {
        onClose(false);
        setMessage('');
      } else if (message === 'An error occurred while checking the content API.') {
        onClose(false);
        setMessage('');
      } else if (message === 'Are you sure you want to cancel? Click again to navigate back.') {
        onClose(false);
        setMessage('');
      }
    } else {
      try {
        setIsLoading(true);
        const isValid = await checkTemplateNameValidity(localTemplateName);
        if (!isValid) return;
        /* Not using code from here as reseting the whole canvas if new template is created */
        // const htmlData = createmode === 'true' && document.querySelector('#editor')?.innerHTML;

        // const findDoc = document.querySelectorAll('.template-input-selector');
        // let fieldsList = [];
        // if (findDoc.length) {
        //   const res = getInputFields(findDoc);
        //   fieldsList.inputFields = res;
        // }

        // const findSelectDropDown = document.querySelectorAll('.template-dropdown');
        // const selectDetails = [];
        // if (findSelectDropDown?.length) {
        //   getDropdownFields(findSelectDropDown, selectDetails);
        // }
        // fieldsList.selectFields = selectDetails;

        // const tempDiv = document.createElement('div');
        // tempDiv.innerHTML = htmlData;

        // mapTables(tempDiv);

        // const thumbnailData = tempDiv.innerHTML;
        // const thumbnail = await GenerateThumbnail(thumbnailData);
        // const data = {
        //   templateName: localTemplateName,
        //   templateHtml: tempDiv.innerHTML,
        //   templateConfig: {
        //     fields: fieldsList.inputFields?.length ? fieldsList.inputFields : [],
        //     dropdownField: fieldsList.selectFields?.length ? fieldsList.selectFields : [],
        //     borderData: JSON.stringify(borderAndMargin.border),
        //     marginData: JSON.stringify(borderAndMargin.margin),
        //     editorPageSize: editorPageSize || pageSizes[0],
        //     stampConfig: stampConfig,
        //     ...isAdditionalAmountRequired,
        //     ...additionalCharges
        //   },
        //   stampConfig
        // };

        // data.templateThumbnail = thumbnail || '';
        /* Till here */

        const newTemplateData = {
        templateName: localTemplateName,
        templateHtml: `<p><br data-cke-filler="true"></p>`,
        templateThumbnail: '',
        templateConfig: {}
      };
        const response = await createTemplate(newTemplateData);
        if (response.status === 200) {
          navigate(`/edit?createmode=true&fileId=${response.templateId}`);
          document.querySelector('#editor').innerHTML = newTemplateData.templateHtml;
          /* Reload the window to reset the editor canvas */
          window.location.reload();
          dispatch(holdTemplateNames(localTemplateName));
          setShowTextField(false);
          setMessage('');
          onClose(false);
          dispatch(updateContent(''));
        } else {
          setMessage('An error occurred while processing the API request.');
        }
      } catch (error) {
        setMessage(error.message);
      }finally {
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <Dialog
        open={open}
        PaperProps={{
          style: {
            width: '312px',
            borderRadius: '8px'
          }
        }}
      >
        <DialogTitle>{showTextField ? 'Enter new template name' : 'Confirmation'}</DialogTitle>
        <DialogContent>
          {showTextField ? (
            <TextField
              margin='dense'
              placeholder='Enter New Template Name'
              InputProps={{ style: { borderRadius: '8px' } }}
              fullWidth
              maxLength={30}
              value={localTemplateName}
              onChange={e => setLocalTemplateName(e.target.value)}
            />
          ) : null}
          {message && <Typography sx={{ color: 'black' }}>{message}</Typography>}
        </DialogContent>
        <DialogActions>
          <PrimaryButton
            value={showTextField ? 'Close' : 'Cancel'}
            backgroundColor='transparent'
            height='40px'
            weight='100px'
            padding='10px 16px'
            border='1px solid #B7D423'
            onClick={handleCancelTemplate}
          />
          <PrimaryButton
            value={showTextField ? 'Continue' : 'Confirm'}
            backgroundColor='#B7D423'
            height='40px'
            weight='100px'
            padding='10px 16px'
            onClick={handleCreateNewTemplate}
          />
        </DialogActions>
      </Dialog>
      {isLoading && <Loading open={isLoading} onClose={() => setIsLoading(false)} />}
    </>
  );
};

export default CreateNewTemplate;
